import type { WorkflowDefinitionDocument, WorkflowProcessDataField } from './platform-workflow-definition-lifecycle.models';
import { processDataErrors, processDataShapeError, supportsWorkflowProcessData } from './workflow-process-data';

export interface WorkflowProcessDataDraft { fields: WorkflowProcessDataField[]; }

/** Replaces only the declared schema. This never supplies values to a workflow run. */
export function applyWorkflowProcessData(
  document: WorkflowDefinitionDocument,
  fields: readonly WorkflowProcessDataField[],
): WorkflowDefinitionDocument {
  if (!supportsWorkflowProcessData(document.payloadSchemaVersion))
    throw new Error('This saved workflow format does not support editing shared data. Its original content is retained.');
  const sourceIssue = processDataShapeError(document.processData);
  if (sourceIssue) throw new Error(sourceIssue);
  const draftIssue = processDataShapeError({ fields });
  if (draftIssue) throw new Error(draftIssue);
  // Keep the existing deliberate Apply normalization, including optional member presence.
  const nextFields = fields.map(field => ({ ...field, label: field.label.trim(),
    ...(field.type === 'record-reference' ? { recordTypeCode: field.recordTypeCode ?? '' } : {}) }));
  let errors: string[];
  try { errors = processDataErrors(nextFields, document); }
  catch { throw new Error('Some retained shared-data dependencies are unavailable. Their original settings and your input are preserved.'); }
  if (errors.length) throw new Error(errors.join(' '));
  return { ...document, processData: { fields: structuredClone(nextFields) } };
}
